import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatchInfoDTO } from '@solverml/api';

/**
 * Componente "Dumb" (Vista) que muestra la cabecera
 * de un detalle de partido (Equipos, Marcador, Info).
 */
@Component({
  selector: 'app-match-detail-header',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    RouterLink,
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './match-detail-header.component.html',
  styleUrls: ['./match-detail-header.component.scss']
})
export class MatchDetailHeaderComponent {
  /**
   * La información general del partido obtenida del StateService.
   */
  @Input({ required: true }) matchInfo!: MatchInfoDTO | null;
}
